import { TranRecordModel } from "./tran-record.model"

export class HandleCorSModel {
    lngClientNo: number
    lngPetNo: number
    intCodeNo: number
    intCodeType: number
    strStatus: string
    strReqEmp: string
    intEmpNo: number
    Trans: TranRecordModel[]
    intTotalIdx: number
    intIndex: number
    strCodeName: string
    strCodeDesc: string
    intClinicNo: number

    constructor(
        lngClientNo: number,
        lngPetNo: number,
        intCodeNo: number,
        intCodeType: number,
        strStatus: string,
        strReqEmp: string,
        intEmpNo: number,
        Trans: TranRecordModel[],
        intTotalIdx: number,
        intIndex: number,
        strCodeName: string,
        strCodeDesc: string,
        intClinicNo: number
    ) {
        this.lngClientNo = lngClientNo
        this.lngPetNo = lngPetNo
        this.intCodeNo = intCodeNo
        this.intCodeType = intCodeType
        this.strStatus = strStatus
        this.strReqEmp = strReqEmp
        this.intEmpNo = intEmpNo
        this.Trans = Trans
        this.intTotalIdx = intTotalIdx
        this.intIndex = intIndex
        this.strCodeName = strCodeName
        this.strCodeDesc = strCodeDesc
        this.intClinicNo = intClinicNo
    }
}